import React, { cloneElement, FC, useState } from 'react';
import styles from './styles.scss';
import AcSwipe from 'ac-components/ac-swiper';
import classNames from 'classnames';
import { os } from '@utils/device-utils';
import { useTranslation } from 'hooks/use-translation';


const GrowthSection: FC = () => {
	const { transData, list } = useTranslation('happyKids.growth')
	const ListRender = list.map((item, index) => {
		return (
			<div className={styles['li-item']}
				key={index}

			>
				<img loading='lazy' src={item.img} alt="" />
			</div>
		)
	})


	return (
		<section className={styles['ac-growth']}>
			<div className={styles['ac-growth-container']}>
				<img className={styles['ac-growth-img-1']} src="https://web-data.zmlearn.com/image/gaSkUgvLPRM75GGa7Kgdzi/%E6%98%9F%E5%BD%A2%402x.png" alt="" loading='lazy' />
				<img className={styles['ac-growth-img-2']} src="https://web-data.zmlearn.com/image/69dPYocUip8xLZbXp4M4Rd/%E8%AF%BE%E7%A8%8B-right-bg%402x.png" alt="" loading='lazy' />
				<img className={styles['ac-growth-img-3']} src="https://web-data.zmlearn.com/image/ew9t5DFGrJEb8FyKTSMLuB/%E8%AF%BE%E7%A8%8B%E5%8F%B3%E4%BE%A7%E4%B9%A6%E5%8C%85%402x.png" alt="" loading='lazy' />
				<h1><span>{transData.title}</span></h1>
				<AcSwipe className={classNames(styles['ac-growth-banner'], 'ac-growth-banner')}
					loop={true}
					spaceBetween={24}
					pagination={{ clickable: true, }}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					slidesPerView={1}
				>{ListRender}</AcSwipe>
			</div>
		</section >
	);
}

export default GrowthSection
